import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconList } from '@sorare/core/src/atoms/icons/system/iconList.ts';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { DisplayL } from '@sorare/core/src/atoms/typography';
import { scoutingCenter } from '@sorare/core/src/lib/glossary';
import {
  laptopAndAbove,
  tabletAndAbove,
} from '@sorare/core/src/style/mediaQuery';

import { AddWatchlistButton } from '#src/components/watchlists/AddWatchlistButton/index.tsx';

const Root = styled(Vertical)`
  background: linear-gradient(180deg, #0f1f4a, rgba(16, 16, 16, 0.2));
  align-items: flex-start;
  padding: var(--double-unit);
  @media ${tabletAndAbove} {
    padding: var(--triple-unit);
  }
`;

const Title = styled(DisplayL)`
  @media ${laptopAndAbove} {
    font-size: calc(12 * var(--unit));
    line-height: 1.1;
  }
`;

const AlignEnd = styled.div`
  align-self: flex-end;
`;

type Props = {
  onAddWatchlist: () => void;
};
export const WatchlistsHeader = ({ onAddWatchlist }: Props) => {
  return (
    <Root>
      <AlignEnd>
        <AddWatchlistButton
          size="small"
          color="secondary"
          blur
          onSuccess={onAddWatchlist}
        />
      </AlignEnd>
      <FontAwesomeIcon icon={iconList} size="4x" />
      <Title>
        <FormattedMessage {...scoutingCenter.watchlists} />
      </Title>
    </Root>
  );
};
